// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-menu-eventos{
    left: 0px;
    position: absolute;
    width: 40%;
    /* background-color: aliceblue; */
    /* height: 15%; */
    display: flex;
}
.cont-option-eventos{
    position: relative;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
}
.selector-multiple{
  left: -5%;
  position: relative;
    width: 80%;
  height: 20px;
  line-height: 28px;
  border: 2px solid transparent;
  border-radius: var(--border-radios-small);
  outline: none;
  background-color: #ffffffb2;
  color: #424242;
  font-size: 14px;
  transition: .3s ease;
  color: rgba(240, 248, 255, 0.795);
  display: flex;
}
.selector-cont-text{
 position: relative;
 width: 80%;
 height: 100%;
 display: flex;
 justify-content: center;
 align-items: center;
 color: var(--txt-color);
 font-size: var(--font-size-small);
 white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.selector-cont-depliegue{
    position: relative;
    width: 20%;
    height: 100%;
    border-left: 2px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
}
.select-multiple-list{
  left: 5%;
  position: relative;
    position: absolute;
    width: 80%;
    height: auto;
    top: 100%;
    z-index: 3;
    background-color: var(--white-color);
    border: #959595 1px solid;
    border-radius: var(--border-radios-small);
    max-height: 650%;
  overflow: auto;

}
.row-option-select-list{
    position: relative;
    width: 100%;
    height: 25px;
    display: flex;

}
.row-option-select-list:hover{
  cursor: pointer;
  background-color: var(--back-error-color);
}
.cont-row-check-option{
    position: relative;
    display: flex;
    width: 20%;
    height: 100%;
    justify-content: center;
    align-items: center;
}
.cont-row-text-option{
    position: relative;
    display: flex;
    width: 80%;
    height: 100%;
    justify-content: center;
    align-items: center;
}
/* Hide the default checkbox */
.container-check-select-multiple input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  .container-check-select-multiple {
    display: flex;
    gap: 10px;
  }
  
  
  /* Create a custom checkbox */
  .checkmark {
    position: relative;
    box-shadow: rgb(255, 84, 0) 0px 0px 0px 2px;
    background-color: rgba(16, 16, 16, 0.5);
    height: 20px;
    width: 20px;
    margin-right: 10px;
    flex-shrink: 0;
    margin-top: -1px;
    transition: all 0.2s ease 0s;
    cursor: pointer;
    transform-origin: 0px 10px;
    border-radius: 4px;
    margin: -1px 10px 0px 0px;
    padding: 0px;
    box-sizing: border-box;
  }
  
  .container-check-select-multiple input:checked ~ .checkmark {
    box-shadow: rgb(255, 84, 0) 0px 0px 0px 2px;
    background-color: rgba(245, 24, 24, 0.5);
    height: 20px;
    width: 20px;
    margin-right: 10px;
    flex-shrink: 0;
    margin-top: -1px;
    transition: all 0.2s ease 0s;
    cursor: pointer;
    transform-origin: 0px 10px;
    border-radius: 4px;
    margin: -1px 10px 0px 0px;
    padding: 0px;
    box-sizing: border-box;
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .container-check-select-multiple input:checked ~ .checkmark:after {
    display: block;
  }
  
  /* Style the checkmark/indicator */
  .container-check-select-multiple .checkmark:after {
    left: 0.45em;
    top: 0.25em;
    width: 0.25em;
    height: 0.5em;
    border: solid white;
    border-width: 0 0.15em 0.15em 0;
    transform: rotate(45deg);
    transition: all 500ms ease-in-out;
  }

  .row-option-select-list input{
    width: 10%;
    position: relative;
    left: 10%;
  }
  .row-option-select-list label{
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .option_bloqueado {
    pointer-events: none;
    opacity: 0.5; /* Puedes reducir la opacidad para indicar visualmente que está inactivo */
  }
  .headerbtn:hover{
    background-color: #95959538;
    cursor: pointer;
  }
  .expandLogoD:hover{
    height: 120%;
    cursor: pointer;
  }
  .contEventsErrorModal{
    position: relative;
    width: 100%;
    height: 100%;
    /* left: 37%;
    top:-100%; */
    background:var(--white-color);
    /* border: 1px solid red; */
    border-radius:5px;
    z-index: 30;
    display: block;
    justify-content: center;
    align-items: center;
  }
  .contEventsError{
    position: absolute;
    width: 50%;
    height: 100%;
    left: 37%;
    top:-100%;
    background:#161935bd;
    border: 1px solid red;
    border-radius:5px;
    z-index: 30;
    display: block;
    justify-content: center;
    align-items: center;
  }
  .contEventsErrorOpened{
    position: absolute;
    width: 18%;
    height: 35%;
    left: 68%;
    top:0%;
    background:#1d0c0ce0;
    border: 1px solid red;
    border-radius:5%;
    z-index: 30;
    /* display: flex; */
    justify-content: center;
    align-items: center;
  }
  .compactcontEventsError{
    width: 100%;
    height: 93%;
    display: flex;
    justify-content: center;

overflow-y: auto;
  }
  .titleContEventsError{
    position: relative;
    width: 100%;
    height: 7%;
    /* background: var(--third-color); */
    border-radius: 5px 5px 0px 0px;
    color: var(--main-color);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: small;
  }
  .topContEventsError{
    position: relative;
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color:aliceblue;
    font-size: x-small;
  }
  .bodyContEventsError{
    position: relative;
    width: 100%;
    height: 60%;
   
  }
  .rowDeviceEventsError{
    position: relative;
    width: 100%;
    height: 15%;
    color: red;
    font-size: x-small;
    display: flex;
    justify-content: center;
    align-items: center;
  }
.contLogsEventsError{
  position: relative;
  width: 96%;
  height: 96%;
  overflow: auto;
}
  .RowGlobeLogError{
    position: relative;
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;

  }
  .globeLogError{
    position: relative;
    width: 90%;
    height: 70%;
    border-radius: var(--border-radios-small);
    border: 1px solid var(--border-table-color);
    display: flex;
    justify-content: center;
    align-items: center;

  }
  .bodyGlobeLogError{
    position: relative;
    width: 100%;
    height: 99%;
    display: flex;
    
  }
  .indexGlobeLogError{
    position: relative;
    width: 5%;
    height: 100%;
    background-color: var(--txt-color-low);
    border-radius: var(--border-radios-small) 0px 0px var(--border-radios-small);
    /* border-left: 1px solid red;
    border-top: 1px solid red;
    border-bottom: 2px solid red;
    border-right:1px solid red ; */
    color: var(--white-color);
    writing-mode: sideways-lr; 
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

  }
  .compactInfoGlobeLogError{
    position: relative;
    width: 93%;
    height: 98%;
    left:2%
  }
  .msgGlobeError{
    position: relative;
    width: 100%;
    height: 50%;
    color: var(--txt-color);
    font-size: var(--font-size-small);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .detailGlobeError{
    position: relative;
    width: 100%;
    height: 50%;
    color: rgb(255, 103, 123);
    font-size: var(--font-size-small);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow: auto;
  }`, "",{"version":3,"sources":["webpack://./src/components/styles/TableAlerts.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,iCAAiC;IACjC,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;AACA;EACE,SAAS;EACT,kBAAkB;IAChB,UAAU;EACZ,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,yCAAyC;EACzC,aAAa;EACb,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iCAAiC;EACjC,aAAa;AACf;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,iCAAiC;CACjC,mBAAmB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;EACE,QAAQ;EACR,kBAAkB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,yBAAyB;IACzB,yCAAyC;IACzC,gBAAgB;EAClB,cAAc;;AAEhB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;;AAEjB;AACA;EACE,eAAe;EACf,yCAAyC;AAC3C;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;AACA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;;EAGA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,2CAA2C;IAC3C,uCAAuC;IACvC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,2CAA2C;IAC3C,wCAAwC;IACxC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,YAAY,EAAE,0EAA0E;EAC1F;EACA;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;gBACY;IACZ,6BAA6B;IAC7B,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,SAAS;IACT,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,MAAM;IACN,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;;AAE3B,gBAAgB;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oCAAoC;IACpC,8BAA8B;IAC9B,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;;EAEb;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;AACF;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;EAErB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yCAAyC;IACzC,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;EAErB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;;EAEf;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,sCAAsC;IACtC,4EAA4E;IAC5E;;;kCAG8B;IAC9B,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;EAEpB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX;EACF;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB","sourcesContent":[".cont-menu-eventos{\r\n    left: 0px;\r\n    position: absolute;\r\n    width: 40%;\r\n    /* background-color: aliceblue; */\r\n    /* height: 15%; */\r\n    display: flex;\r\n}\r\n.cont-option-eventos{\r\n    position: relative;\r\n    display: flex;\r\n    width: 50%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.selector-multiple{\r\n  left: -5%;\r\n  position: relative;\r\n    width: 80%;\r\n  height: 20px;\r\n  line-height: 28px;\r\n  border: 2px solid transparent;\r\n  border-radius: var(--border-radios-small);\r\n  outline: none;\r\n  background-color: #ffffffb2;\r\n  color: #424242;\r\n  font-size: 14px;\r\n  transition: .3s ease;\r\n  color: rgba(240, 248, 255, 0.795);\r\n  display: flex;\r\n}\r\n.selector-cont-text{\r\n position: relative;\r\n width: 80%;\r\n height: 100%;\r\n display: flex;\r\n justify-content: center;\r\n align-items: center;\r\n color: var(--txt-color);\r\n font-size: var(--font-size-small);\r\n white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.selector-cont-depliegue{\r\n    position: relative;\r\n    width: 20%;\r\n    height: 100%;\r\n    border-left: 2px solid gainsboro;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.select-multiple-list{\r\n  left: 5%;\r\n  position: relative;\r\n    position: absolute;\r\n    width: 80%;\r\n    height: auto;\r\n    top: 100%;\r\n    z-index: 3;\r\n    background-color: var(--white-color);\r\n    border: #959595 1px solid;\r\n    border-radius: var(--border-radios-small);\r\n    max-height: 650%;\r\n  overflow: auto;\r\n\r\n}\r\n.row-option-select-list{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 25px;\r\n    display: flex;\r\n\r\n}\r\n.row-option-select-list:hover{\r\n  cursor: pointer;\r\n  background-color: var(--back-error-color);\r\n}\r\n.cont-row-check-option{\r\n    position: relative;\r\n    display: flex;\r\n    width: 20%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.cont-row-text-option{\r\n    position: relative;\r\n    display: flex;\r\n    width: 80%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n/* Hide the default checkbox */\r\n.container-check-select-multiple input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n    height: 0;\r\n    width: 0;\r\n  }\r\n  \r\n  .container-check-select-multiple {\r\n    display: flex;\r\n    gap: 10px;\r\n  }\r\n  \r\n  \r\n  /* Create a custom checkbox */\r\n  .checkmark {\r\n    position: relative;\r\n    box-shadow: rgb(255, 84, 0) 0px 0px 0px 2px;\r\n    background-color: rgba(16, 16, 16, 0.5);\r\n    height: 20px;\r\n    width: 20px;\r\n    margin-right: 10px;\r\n    flex-shrink: 0;\r\n    margin-top: -1px;\r\n    transition: all 0.2s ease 0s;\r\n    cursor: pointer;\r\n    transform-origin: 0px 10px;\r\n    border-radius: 4px;\r\n    margin: -1px 10px 0px 0px;\r\n    padding: 0px;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .container-check-select-multiple input:checked ~ .checkmark {\r\n    box-shadow: rgb(255, 84, 0) 0px 0px 0px 2px;\r\n    background-color: rgba(245, 24, 24, 0.5);\r\n    height: 20px;\r\n    width: 20px;\r\n    margin-right: 10px;\r\n    flex-shrink: 0;\r\n    margin-top: -1px;\r\n    transition: all 0.2s ease 0s;\r\n    cursor: pointer;\r\n    transform-origin: 0px 10px;\r\n    border-radius: 4px;\r\n    margin: -1px 10px 0px 0px;\r\n    padding: 0px;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n  }\r\n  \r\n  .container-check-select-multiple input:checked ~ .checkmark:after {\r\n    display: block;\r\n  }\r\n  \r\n  /* Style the checkmark/indicator */\r\n  .container-check-select-multiple .checkmark:after {\r\n    left: 0.45em;\r\n    top: 0.25em;\r\n    width: 0.25em;\r\n    height: 0.5em;\r\n    border: solid white;\r\n    border-width: 0 0.15em 0.15em 0;\r\n    transform: rotate(45deg);\r\n    transition: all 500ms ease-in-out;\r\n  }\r\n\r\n  .row-option-select-list input{\r\n    width: 10%;\r\n    position: relative;\r\n    left: 10%;\r\n  }\r\n  .row-option-select-list label{\r\n    width: 90%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .option_bloqueado {\r\n    pointer-events: none;\r\n    opacity: 0.5; /* Puedes reducir la opacidad para indicar visualmente que está inactivo */\r\n  }\r\n  .headerbtn:hover{\r\n    background-color: #95959538;\r\n    cursor: pointer;\r\n  }\r\n  .expandLogoD:hover{\r\n    height: 120%;\r\n    cursor: pointer;\r\n  }\r\n  .contEventsErrorModal{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    /* left: 37%;\r\n    top:-100%; */\r\n    background:var(--white-color);\r\n    /* border: 1px solid red; */\r\n    border-radius:5px;\r\n    z-index: 30;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .contEventsError{\r\n    position: absolute;\r\n    width: 50%;\r\n    height: 100%;\r\n    left: 37%;\r\n    top:-100%;\r\n    background:#161935bd;\r\n    border: 1px solid red;\r\n    border-radius:5px;\r\n    z-index: 30;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .contEventsErrorOpened{\r\n    position: absolute;\r\n    width: 18%;\r\n    height: 35%;\r\n    left: 68%;\r\n    top:0%;\r\n    background:#1d0c0ce0;\r\n    border: 1px solid red;\r\n    border-radius:5%;\r\n    z-index: 30;\r\n    /* display: flex; */\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .compactcontEventsError{\r\n    width: 100%;\r\n    height: 93%;\r\n    display: flex;\r\n    justify-content: center;\r\n\r\noverflow-y: auto;\r\n  }\r\n  .titleContEventsError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 7%;\r\n    /* background: var(--third-color); */\r\n    border-radius: 5px 5px 0px 0px;\r\n    color: var(--main-color);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    font-size: small;\r\n  }\r\n  .topContEventsError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 25%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    color:aliceblue;\r\n    font-size: x-small;\r\n  }\r\n  .bodyContEventsError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 60%;\r\n   \r\n  }\r\n  .rowDeviceEventsError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 15%;\r\n    color: red;\r\n    font-size: x-small;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n.contLogsEventsError{\r\n  position: relative;\r\n  width: 96%;\r\n  height: 96%;\r\n  overflow: auto;\r\n}\r\n  .RowGlobeLogError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 25%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n  }\r\n  .globeLogError{\r\n    position: relative;\r\n    width: 90%;\r\n    height: 70%;\r\n    border-radius: var(--border-radios-small);\r\n    border: 1px solid var(--border-table-color);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n  }\r\n  .bodyGlobeLogError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 99%;\r\n    display: flex;\r\n    \r\n  }\r\n  .indexGlobeLogError{\r\n    position: relative;\r\n    width: 5%;\r\n    height: 100%;\r\n    background-color: var(--txt-color-low);\r\n    border-radius: var(--border-radios-small) 0px 0px var(--border-radios-small);\r\n    /* border-left: 1px solid red;\r\n    border-top: 1px solid red;\r\n    border-bottom: 2px solid red;\r\n    border-right:1px solid red ; */\r\n    color: var(--white-color);\r\n    writing-mode: sideways-lr; \r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n\r\n  }\r\n  .compactInfoGlobeLogError{\r\n    position: relative;\r\n    width: 93%;\r\n    height: 98%;\r\n    left:2%\r\n  }\r\n  .msgGlobeError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 50%;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n  }\r\n  .detailGlobeError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 50%;\r\n    color: rgb(255, 103, 123);\r\n    font-size: var(--font-size-small);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    overflow: auto;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
